export default "__VITE_ASSET__DF5V_dZn__"